module.exports = __webpack_public_path__ + "archivist_badge_01.jpg?ed5a4ebca6cf75f73cf7c99c2d006d62";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge/archivist_badge_01.jpg
// module id = 376
// module chunks = 0